import { createContext, useContext } from 'react';

import type { FeatureFlagOverrideState } from './types.ts';

export const FeatureFlagOverrideContext =
  createContext<Nullable<FeatureFlagOverrideState>>(null);

export const useFeatureFlagOverrideContext = () => {
  const state = useContext(FeatureFlagOverrideContext);

  if (!state) {
    throw new Error(
      'useFeatureFlagOverrideContext must be used within a FeatureFlagOverrideProvider'
    );
  }

  return state;
};
